/* ======================================================
   FOUR CACTUS JOURNAL
====================================================== */

document.addEventListener("DOMContentLoaded", function () {

  /* ------------------------------
     Reading Time
  ------------------------------ */

  document.querySelectorAll(".reading-time").forEach(function(el){

      let text = el.dataset.content || "";

      text = text.replace(/<[^>]+>/g,'');

      const words = text.trim().split(/\s+/).length;

      const minutes = Math.max(1, Math.ceil(words / 220));

      el.innerHTML = minutes + " min read";

  });


  /* ------------------------------
     Reveal Animation
  ------------------------------ */

  const cards = document.querySelectorAll(".FC-Card");

  if("IntersectionObserver" in window){

      const observer = new IntersectionObserver(function(entries){

          entries.forEach(function(entry){

              if(entry.isIntersecting){

                  entry.target.classList.add("FC-Reveal");

              }

          });

      },{

          threshold:.15

      });

      cards.forEach(function(card){

          observer.observe(card);

      });

  }

});